import { render } from "./ShareProducts.vue?vue&type=template&id=bcecfb20&scoped=true"
import script from "./ShareProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareProducts.vue?vue&type=script&setup=true&lang=js"

import "./ShareProducts.vue?vue&type=style&index=0&id=bcecfb20&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcecfb20"],['__file',"resources/js/components/whatsapp-managment/includes/ShareProducts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bcecfb20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bcecfb20', __exports__)) {
    console.log('reload')
    api.reload('bcecfb20', __exports__)
  }
  
  module.hot.accept("./ShareProducts.vue?vue&type=template&id=bcecfb20&scoped=true", () => {
    console.log('re-render')
    api.rerender('bcecfb20', render)
  })

}


export default __exports__